import React, { useEffect, useState, useMemo } from "react";
import "../../StyleSheet/MainComponent/Role/Role.scss";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Header from "../../Component/AppComponent/Header/Header";
import home from "../../Assets/AppComponent/Logo/Home.svg";
import ReactTable from "../../Component/AppComponent/Table";
import { setUserGetActions, usereditid } from "../../Redux/Slice";

function CreateUser() {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const userdata = useSelector((state) => state.UserGetData);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [tabledata, settabledata] = useState([]);
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [datacount, setdatacount] = useState();
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    dispatch(
      setUserGetActions({
        search: searchQuery,
        page: dtpageindex,
        // page_size: dtpagesize,

      })
    );
  }, [searchQuery, dtpageindex]);

  useEffect(() => {
    //console.log(userdata);
    if (userdata?.UserGet?.data?.length > 0) {
      settabledata(userdata?.UserGet?.data);
      setdatacount(userdata?.UserGet?.values)
    }
  }, [userdata]);
  const breadcrumbsData = [
    {
      id: "1",
      href: "/",
      source: home,
      title: "DASHBOARD",
    },
    // {
    //   id: "2",
    //   href: "/",
    //   source: Create User,
    //   title: "DASHBOARD",
    // },
  ];

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };

  const handleEdit = (id, e) => {
    dispatch(usereditid(id));
    navigate("/createuserform");
  };
  const InvoiceColumn = useMemo(
    () => [
      {
        Header: "First Name",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                {row.row.original.first_name != null
                  ? row.row.original.first_name
                  : "--"}
              </span>
            </>
          );
        },
      },
      // {
      //   Header: "Last Name",
      //   accessor: "",
      //   Cell: (row) => {
      //     return (
      //       <>
      //         <span>{row.row.original.last_name != null ? row.row.original.last_name : "--"}</span>

      //       </>
      //     );
      //   },
      // },
      {
        Header: "Email  ",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              {/* <div
                style={{
                  width: "50%",
                  margin: "0 auto",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              > */}
              <span>
                {row.row.original.email != null ? row.row.original.email : "--"}
              </span>
              {/* </div> */}
            </>
          );
        },
      },
      {
        Header: "Role",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                {row.row.original.role != null ? row.row.original.role : "--"}
              </span>
            </>
          );
        },
      },
      {
        Header: "Actions",
        accessor: "",
        Cell: (row) => {
          return (
            <div className="plantProjectActions">
              <button
                type="button"
                onClick={(e) => handleEdit(row.row.original.id, e)}
              >
                <span style={{ color: "#ef4d39" }}>
                  {" "}
                  <i
                    class="fa-solid fa-pen"
                    style={{
                      fontSize: "13px",
                      paddingRight: "3px",
                      color: "#ef4d39",
                    }}
                  ></i>
                  Edit{" "}
                </span>
              </button>
            </div>
          );
        },
      },
    ],
    []
  );
  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <Header breadCrumbsData={breadcrumbsData} heading="Create User" />

        <div className="UserDetails">
          <button
            style={{
              background:
                "linear-gradient(90deg, #F26639 -3.66%, #F79C37 -3.65%, #EF4D39 100.34%)",
            }}
            className="custom-button"
            onClick={() => {
              dispatch(usereditid(""));
              navigate("/createuserform");
            }}
          >
            CREATE USER
          </button>
        </div>

        <ReactTable
          columns={InvoiceColumn}
          data={tabledata}
          pagesize={pagesize}
          pageindex={pageindex}
          dtpagesize={dtpagesize}
          dtpageindex={dtpageindex}
          datacount={datacount}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          search={true}
        />
      </div>
    </>
  );
}

export default CreateUser;
